module.exports = __webpack_public_path__ + "assets/img/01_redis-structure.d7aeb205.png";